// extracted by mini-css-extract-plugin
var _1 = "b_7mY";
export { _1 as "icon" }
